
import { VALIDATE_PW_TOKEN } from '@/api/apolloCustomerMutations';

export default {
  name: 'AuthPage',
  props: {
    type: {
      type: String,
      default: 'login',
    },
  },
  head() {
    return {
      htmlAttrs: {
        id: 'authPage',
      },
    };
  },
  data() {
    return {
      isLoading: false,
    };
  },
  computed: {
    isForgotPage() {
      return this.type === 'forgot' || this.type === 'resetPassword';
    },
    linkMessage() {
      return this.isForgotPage ? 'Back to Log In' : 'Return to Previous Page';
    },
    messages() {
      return this.$store.state.messages;
    },
  },
  mounted() {
    if (this.type === 'resetPassword') {
      this.checkPWToken();
    }
  },
  methods: {
    setMessage(message) {
      if (message) {
        this.$store.commit('setMessages', [{
          id: `_${Math.random().toString(36).substr(2, 9)}`,
          ...message,
        }]);
      }
    },
    goBack() {
      this.$store.commit('setMessages', []);
      if (this.isForgotPage) {
        this.$router.push('/customer/account/login');
      } else {
        this.$router.go(-1);
      }
    },
    async checkPWToken() {
      const { id, token } = this.$route.query;
      if (id && token) {
        sessionStorage.setItem('changePWId', id);
        sessionStorage.setItem('changePWToken', token);
        this.$router.replace({ path: this.$route.path });
      }
      const changePWID = Number(sessionStorage.getItem('changePWId'));
      const changePWToken = sessionStorage.getItem('changePWToken');
      if (Number.isNaN(changePWID) || !changePWToken) {
        await this.$router.push('/customer/account/forgotpassword');
        return;
      }
      this.isLoading = true;
      try {
        const { customer: { validatePWToken } } = await this.$graphql.default
          .request(VALIDATE_PW_TOKEN, { id: changePWID, token: changePWToken }) || {};

        if (!validatePWToken?.success) {
          this.$router.push('/customer/account/forgotpassword');
          if (validatePWToken?.message) {
            this.setMessage({
              type: validatePWToken.success ? 'success' : 'error',
              code: validatePWToken.code,
              content: validatePWToken.message,
            });
          }
        }
      } catch (error) {
        this.errorHandler(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
